/* eslint-disable prettier/prettier */
/* eslint-disable import/named */
import { CurrencyDropdown, DropdownOption } from '../claims/new/typings';
import React from 'react';
import Select, { ValueType } from 'react-select';

const currencies = [
  'AED',
  'AFN',
  'ALL',
  'AMD',
  'ANG',
  'AOA',
  'ARS',
  'AUD',
  'AWG',
  'AZN',
  'BAM',
  'BBD',
  'BDT',
  'BGN',
  'BHD',
  'BIF',
  'BMD',
  'BND',
  'BOB',
  'BRL',
  'BSD',
  'BTN',
  'BWP',
  'BYN',
  'BZD',
  'CAD',
  'CDF',
  'CHF',
  'CLP',
  'CNY',
  'COP',
  'CRC',
  'CUC',
  'CUP',
  'CVE',
  'CZK',
  'DJF',
  'DKK',
  'DOP',
  'DZD',
  'EGP',
  'ERN',
  'ETB',
  'EUR',
  'FJD',
  'FKP',
  'GBP',
  'GEL',
  'GGP',
  'GHS',
  'GIP',
  'GMD',
  'GNF',
  'GTQ',
  'GYD',
  'HKD',
  'HNL',
  'HKD',
  'HRK',
  'HTG',
  'HUF',
  'IDR',
  'ILS',
  'IMP',
  'INR',
  'IQD',
  'IRR',
  'ISK',
  'JEP',
  'JMD',
  'JOD',
  'JPY',
  'KES',
  'KGS',
  'KHR',
  'KID',
  'KMF',
  'KPW',
  'KRW',
  'KWD',
  'KYD',
  'KZT',
  'LAK',
  'LBP',
  'LKR',
  'LRD',
  'LSL',
  'LYD',
  'MAD',
  'MDL',
  'MGA',
  'MKD',
  'MMK',
  'MNT',
  'MOP',
  'MRU',
  'MUR',
  'MVR',
  'MWK',
  'MXN',
  'MYR',
  'MZN',
  'NAD',
  'NGN',
  'NIO',
  'NOK',
  'NPR',
  'NZD',
  'OMR',
  'PAB',
  'PEN',
  'PGK',
  'PHP',
  'PKR',
  'PLN',
  'PRB',
  'PYG',
  'QAR',
  'RON',
  'RON',
  'RSD',
  'RUB',
  'RWF',
  'SAR',
  'SEK',
  'SGD',
  'SHP',
  'SLL',
  'SLS',
  'SOS',
  'SRD',
  'SSP',
  'STN',
  'SYP',
  'SZL',
  'THB',
  'TJS',
  'TMT',
  'TND',
  'TOP',
  'TRY',
  'TTD',
  'TVD',
  'TWD',
  'TZS',
  'UAH',
  'UGX',
  'USD',
  'UYU',
  'UZS',
  'VES',
  'VND',
  'VUV',
  'WST',
  'XAF',
  'XCD',
  'XOF',
  'XPF',
  'ZAR',
  'ZMW',
  'ZWB',
];

export const CurrencySelector: React.FC<CurrencyDropdown> = ({ disabled, selected, onChange }) => {
  const options = currencies.map((currency: string) => {
    return {
      value: currency,
      label: currency,
    };
  });
  return (
    <Select
      styles={{
        menu: (provided, state) => ({
          ...provided,
          width: '100px',
          margin: 0,
        }),
        menuList: (provided, state) => ({
          ...provided,
          height: '250px',
          overflowX: 'hidden',
          zIndex: 99,
        }),
      }}
      className="currency-dropdown"
      options={options}
      value={selected}
      isDisabled={disabled}
      onChange={(selectedOption: ValueType<DropdownOption>) => {
        const selectedValue: string = (selectedOption as unknown as DropdownOption).value;
        return onChange(selectedValue as string);
      }}
    />
  );
};
